export const HOME_STYLE = 'HOME STYLE';
export const STATS = 'STATS';
export const SERVICES = 'SEEVICES';
export const SLIDESHOW = 'SLIDESHOW';

export const ABOUT_BANNER = 'ABOUT_BANNER';
export const TEAM_MEMBERS = 'TEAM_MEMBERS';

export const TESTIMONIALS = 'TESTIMONIALS'